import React from "react";
import { TspCard, TspGauge, TspProgressBar } from "../../../components/primitives";

export default function PublicResponseScoreCard({ score }) {
  return (
    <TspCard title="Public Response Score">
      <div className="tsp-response-score">
        <TspGauge value={score.average} max={score.max} label={score.label} color="#2FA96A" />
        <div className="tsp-response-breakdown">
          {score.breakdown.map((row) => (
            <TspProgressBar key={row.label} label={row.label} value={`${row.percent}%`} percent={row.percent} color={row.color} />
          ))}
        </div>
        <p className="tsp-muted-text tsp-response-total">{score.totalResponses}</p>
      </div>
    </TspCard>
  );
}
